<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Customers</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical align-items-center" routerLink="/customer/nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="exportCustomers()">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="importCustomers()">
          <input type="file" name="file" class="custom-file-input" id="importcsvcustomer" required (change)="handleCustomerImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
          Importare<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn vertical align-items-center full-width-btn" (click)="downloadCsvFormat()">Scarica il formato CSV</button>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
            <form class="table-row-container row first-row filter" [formGroup]="customerFilterForm" (ngSubmit)="filter()" *ngIf="customerFilterForm">

                <div class="item data-col-10 hideOnPhoneView">
                    <h4 class="title" (click)="navigateOrder('Customer.id')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('Customer.id')"></i>
                      ID
                    </h4>
                    <span class="data">
                      <input type="number" formControlName="Customer.id" min="1000" max="10000" >
                    </span>
                </div>

                <div class="item data-col-30" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <h4 class="title">
                    <i class="sort-icon fas"></i>
                    Owner
                  </h4>
                  <span class="data">
                    <select formControlName="Customer.Group.name">
                      <option value="">Tutti</option>
                      <option value="admin">Admin</option>
                      <option value="operation">Operation</option>
                      <option value="partner">Partner</option>
                    </select>
                  </span>
                </div>

                <div class="item data-col-15" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                    Partner
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="Partner.businessName">
                  </span>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.surname')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                    Cognome
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="User.surname">
                  </span>
                </div>

                <div class="item data-col-15 expertClass">
                  <h4 class="title" (click)="navigateOrder('User.name')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                    Nome</h4>
                  <span class="data">
                    <input type="text" formControlName="User.name">
                  </span>
                </div>

                <div class="item data-col-15 expertClass">
                  <h4 class="title" (click)="navigateOrder('User.email')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                    Email</h4>
                  <span class="data">
                    <input type="text" formControlName="User.email">
                  </span>
                </div>

                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.dob')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.dob')"></i>
                    DATA NASCITA
                  </h4>
                  <span class="data">
                    <div class="date">Da: </div>
                    <input class="date" type="date" formControlName="Customer.dob_from">
                  </span>
                  <span class="data">
                    <div class="date">A: </div>
                    <input class="date" type="date" formControlName="Customer.dob_to">
                  </span>
                </div>

                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.intercom')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.intercom')"></i>
                    Citofono</h4>
                  <span class="data">
                    <input type="text" formControlName="Customer.intercom">
                  </span>
                </div>

                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.phone')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.phone')"></i>
                    Telefono</h4>
                  <span class="data">
                    <input type="text" formControlName="Customer.phone">
                  </span>
                </div>

                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.address')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.address')"></i>
                    Indirizzo</h4>
                  <span class="data">
                    <input type="text" formControlName="Customer.address">
                  </span>
                </div>

                <div class="item center data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.notes')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.notes')"></i>
                    Note</h4>
                  <span class="data">
                    <input type="text" formControlName="Customer.notes">
                  </span>
                </div>

                <div class="item nowrap">
                  <h4 class="title hide-on-mobile">AZIONI</h4>
                  <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                      RICERCA <i class="fas fa-search"></i></button>
                      <br/>
                    <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
                      RESET <i class="fas fa-times-circle"></i></button>
                  </span>
                </div>
            </form>

            <div class="table-row-container row" *ngFor="let customer of customers">

                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      ID
                    </h4>
                    <div class="data data-id">
                      <div>{{ customer?.id || "---" }}</div>
                    </div>
                </div>

                <div class="item data-col-15" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <h4 class="title">
                    <i class="sort-icon fas"></i>
                    Customer Owner</h4>
                  <span class="data">
                    <a [routerLink]="['/customer', 'edit', customer.id]">
                      {{ (customer.createdBy.group.name || "---").toUpperCase() }} 
                      <!-- ({{ (customer.createdBy.name || "") + " " + (customer.createdBy.surname || "") }}) -->
                    </a>
                  </span>
                </div>

                <div class="item data-col-15" *ngIf="groups.includes('admin') || groups.includes('operation')">
                  <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                    Partner</h4>
                  <span class="data">
                    <a [routerLink]="['/customer', 'edit', customer.id]">
                      {{
                        customer?.createdBy?.extraType?.toLowerCase() === 'partner'
                          ? customer?.partner?.businessName || "---"
                          : "---"
                      }}
                    </a>
                  </span>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.surname')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                    Cognome</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.user.surname || "---" }}</a></span>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.name')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                    Nome</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.user.name || "---" }}</a></span>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.email')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                    Email</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.user.email || "---" }}</a></span>
                </div>

                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.dob')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.dob')"></i>
                    DATA NASCITA</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.dob | date:'dd/MM/yyyy'}}</a></span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('Customer.intercom')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('Customer.intercom')"></i>
                      Citofono</h4>
                    <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.intercom || "---" }}</a></span>
                </div>

                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.phone')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.phone')"></i>
                    Telefono</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.phone || "---" }}</a></span>
                </div>
                
                <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.address')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.address')"></i>
                    Indirizzo</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.address || "---" }}</a></span>
                </div>

                <div class="item center data-col-10">
                  <h4 class="title" (click)="navigateOrder('Customer.notes')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Customer.notes')"></i>
                    Note</h4>
                  <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.notes || "---" }}</a></span>
                </div>

                <div class="item nowrap">
                  <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" [routerLink]="['/consegne/nuovo']" [queryParams]="{ customerId: customer.id }">DELIVERY</button>
                    <button class="btn vertical align-items-center" [routerLink]="['/customer/edit', customer.id]">MODIFICA</button>
                    <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteCustomer(customer?.id)">
                      Elimina<i class="ml-10 far fa-trash-alt"></i>
                    </button>
                  </span>
                </div>
            </div>
        </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Customers</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">

        <button class="btn btn-white vertical align-items-center" routerLink="/customer/nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="exportCustomers()">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="importCustomers()">
          <input type="file" name="file" class="custom-file-input" id="importcsvcustomer" required (change)="handleCustomerImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
          Importare<i class="ml-10 fas fa-file-excel"></i>
        </button>
    
        <button class="btn vertical align-items-center full-width-btn" (click)="downloadCsvFormat()">Scarica il formato CSV</button>

      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding scroll-delivery">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="customerFilterForm" (ngSubmit)="filter()" *ngIf="customerFilterForm">

            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Customer.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Customer.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="Customer.id" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-30" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                Owner
              </h4>
              <span class="data">
                <select formControlName="Customer.Group.name">
                  <option value="">Tutti</option>
                  <option value="admin">Admin</option>
                  <option value="operation">Operation</option>
                  <option value="partner">Partner</option>
                </select>
              </span>
            </div>

            <div class="item data-col-15" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner
              </h4>
              <span class="data">
                <input type="text" formControlName="Partner.businessName">
              </span>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.surname')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                Cognome
              </h4>
              <span class="data">
                <input type="text" formControlName="User.surname">
              </span>
            </div>

            <div class="item data-col-15 expertClass">
              <h4 class="title" (click)="navigateOrder('User.name')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                Nome</h4>
              <span class="data">
                <input type="text" formControlName="User.name">
              </span>
            </div>

            <div class="item data-col-15 expertClass">
              <h4 class="title" (click)="navigateOrder('User.email')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                Email</h4>
              <span class="data">
                <input type="text" formControlName="User.email">
              </span>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.dob')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.dob')"></i>
                DATA NASCITA
              </h4>
              <span class="data">
                <div class="date">Da: </div>
                <input class="date" type="date" formControlName="Customer.dob_from">
              </span>
              <span class="data">
                <div class="date">A: </div>
                <input class="date" type="date" formControlName="Customer.dob_to">
              </span>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.intercom')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.intercom')"></i>
                Citofono</h4>
              <span class="data">
                <input type="text" formControlName="Customer.intercom">
              </span>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.phone')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.phone')"></i>
                Telefono</h4>
              <span class="data">
                <input type="text" formControlName="Customer.phone">
              </span>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.address')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.address')"></i>
                Indirizzo</h4>
              <span class="data">
                <input type="text" formControlName="Customer.address">
              </span>
            </div>

            <div class="item center data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.notes')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.notes')"></i>
                Note</h4>
              <span class="data">
                <input type="text" formControlName="Customer.notes">
              </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i></button>
                  <br/>
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
                  RESET <i class="fas fa-times-circle"></i></button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let customer of customers">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ customer?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-15" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                Customer Owner</h4>
              <span class="data">
                <a [routerLink]="['/customer', 'edit', customer.id]">
                  {{ (customer.createdBy.group.name || "---").toUpperCase() }} 
                </a>
              </span>
            </div>

            <div class="item data-col-15" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner</h4>
              <span class="data">
                <a [routerLink]="['/customer', 'edit', customer.id]">
                  {{
                    customer?.createdBy?.extraType?.toLowerCase() === 'partner'
                      ? customer?.partner?.businessName || "---"
                      : "---"
                  }}
                </a>
              </span>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.surname')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                Cognome</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.user.surname || "---" }}</a></span>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.name')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                Nome</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.user.name || "---" }}</a></span>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.email')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                Email</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.user.email || "---" }}</a></span>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.dob')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.dob')"></i>
                DATA NASCITA</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.dob | date:'dd/MM/yyyy'}}</a></span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('Customer.intercom')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Customer.intercom')"></i>
                  Citofono</h4>
                <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.intercom || "---" }}</a></span>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.phone')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.phone')"></i>
                Telefono</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.phone || "---" }}</a></span>
            </div>
            
            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.address')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.address')"></i>
                Indirizzo</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.address || "---" }}</a></span>
            </div>

            <div class="item center data-col-10">
              <h4 class="title" (click)="navigateOrder('Customer.notes')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Customer.notes')"></i>
                Note</h4>
              <span class="data"><a [routerLink]="['/customer', 'edit', customer.id]">{{ customer.notes || "---" }}</a></span>
            </div>

            <div class="item nowrap">
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" [routerLink]="['/consegne/nuovo']" [queryParams]="{ customerId: customer.id }">DELIVERY</button>
                <button class="btn vertical align-items-center" [routerLink]="['/customer/edit', customer.id]">MODIFICA</button>
                <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteCustomer(customer?.id)">
                  Elimina<i class="ml-10 far fa-trash-alt"></i>
                </button>
              </span>
            </div>
        </div>
    </div>
</section>
-->